import * as aes256 from "aes256";

const PERSONAL_LOGIN_STORAGE_KEY = "personal_logon_info";
const ENTERPRISE_LOGIN_STORAGE_KEY = "enterprise_login_info";
const MARINA_LOGIN_STORAGE_KEY = "marina_login_info";
const PROJECT_LOGIN_STORAGE_KEY = "project_login_info";

const encrypt = (storageKey, target) => {
  const key = process.env.VUE_APP_ENCRYPT_KEY;
  const encrypted = aes256.encrypt(key, target);
  localStorage.setItem(storageKey, encrypted);
};

const decrypt = storageKey => {
  const key = process.env.VUE_APP_ENCRYPT_KEY;
  const storage = localStorage.getItem(storageKey);
  return storage === null ? null : aes256.decrypt(key, storage);
};

const clearLoginInfo = storageKey => {
  localStorage.removeItem(storageKey);
};

export const setPersonalLoginInfo = loginInfo => {
  encrypt(PERSONAL_LOGIN_STORAGE_KEY, JSON.stringify(loginInfo));
};

export const getPersonalLoginInfo = () => {
  const loginInfo = decrypt(PERSONAL_LOGIN_STORAGE_KEY);
  return loginInfo === null ? null : JSON.parse(loginInfo);
};

export const clearPersonalLoginInfo = () => {
  clearLoginInfo(PERSONAL_LOGIN_STORAGE_KEY);
};

export const setEnterpriseLoginInfo = loginInfo => {
  encrypt(ENTERPRISE_LOGIN_STORAGE_KEY, JSON.stringify(loginInfo));
};

export const getEnterpriseLoginInfo = () => {
  const loginInfo = decrypt(ENTERPRISE_LOGIN_STORAGE_KEY);
  return loginInfo === null ? null : JSON.parse(loginInfo);
};

export const clearEnterpriseLoginInfo = () => {
  clearLoginInfo(ENTERPRISE_LOGIN_STORAGE_KEY);
};

export const setMarinaLoginInfo = loginInfo => {
  encrypt(MARINA_LOGIN_STORAGE_KEY, JSON.stringify(loginInfo));
};

export const getMarinaLoginInfo = () => {
  const loginInfo = decrypt(MARINA_LOGIN_STORAGE_KEY);
  return loginInfo === null ? null : JSON.parse(loginInfo);
};

export const clearMarinaLoginInfo = () => {
  clearLoginInfo(MARINA_LOGIN_STORAGE_KEY);
};

export const setProjectLoginInfo = loginInfo => {
  encrypt(PROJECT_LOGIN_STORAGE_KEY, JSON.stringify(loginInfo));
};

export const getProjectLoginInfo = () => {
  const loginInfo = decrypt(PROJECT_LOGIN_STORAGE_KEY);
  return loginInfo === null ? null : JSON.parse(loginInfo);
};

export const clearProjectLoginInfo = () => {
  clearLoginInfo(PROJECT_LOGIN_STORAGE_KEY);
};
